import React from 'react'
import { Grid } from '@material-ui/core'
import AdminPage from '../../admin/shared/AdminPage'
import OrionSystemConnectionInfo from './OrionSystemConnectionInfo'
import OrionSystemIntegrations from './OrionSystemIntegrations/OrionSystemIntegrations'

function OrionSystemHome () {
  return (
    <AdminPage>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <OrionSystemConnectionInfo />
        </Grid>
        <Grid item xs={12}>
          <OrionSystemIntegrations />
        </Grid>
      </Grid>
    </AdminPage>
  )
}

export default OrionSystemHome
